import dayjs from 'dayjs';

export const getDatesFromFinyear = (finyear) => {
    const from = dayjs(finyear.From_Date).startOf("day");
    const to = dayjs(finyear.To_Date).endOf('day');
    return ({ from, to });
}

export const getDefaultDate = (finyear) => {
    const from = dayjs(finyear.From_Date).startOf('day');
    const to = dayjs(finyear.To_Date).endOf('day');
    let date = dayjs().startOf('day');
    if ((date < to && date > from) || date.format('DD-MM-YYYY') === to.format('DD-MM-YYYY') || date.format('DD-MM-YYYY') === from.format('DD-MM-YYYY')) {
        return date;
    }
    return to;
}

export const getDefaultDateWithCurrTime = (finyear) => {
    const from = dayjs(finyear.From_Date).startOf('day');
    const to = dayjs(finyear.To_Date).endOf('day');
    let date = dayjs();
    if ((date < to && date > from) || date.format('DD-MM-YYYY') === to.format('DD-MM-YYYY') || date.format('DD-MM-YYYY') === from.format('DD-MM-YYYY')) {
        return date;
    }
    return to;
}